// packages/isomorphic/src/lib/ambulance-types.ts
var AMBULANCE_SERVICE_TYPES = {
  type1: {
    name: "Basic Life Support (BLS)",
    arabicDescription: "\u0646\u0642\u0644 \u0627\u0644\u0645\u0631\u0636\u0649 \u0627\u0644\u0645\u0633\u062A\u0642\u0631\u064A\u0646\u060C \u0625\u0633\u0639\u0627\u0641\u0627\u062A \u0623\u0648\u0644\u064A\u0629 \u0628\u0633\u064A\u0637\u0629"
  },
  type2: {
    name: "Advanced Life Support (ALS)",
    arabicDescription: "\u0631\u0639\u0627\u064A\u0629 \u0637\u0628\u064A\u0629 \u0645\u062A\u0642\u062F\u0645\u0629 \u0623\u062B\u0646\u0627\u0621 \u0627\u0644\u0646\u0642\u0644 \u0644\u0644\u062D\u0627\u0644\u0627\u062A \u0627\u0644\u062D\u0631\u062C\u0629"
  },
  type3: {
    name: "Critical Care",
    arabicDescription: "\u0639\u0646\u0627\u064A\u0629 \u0645\u0631\u0643\u0632\u0629 \u0645\u062A\u0646\u0642\u0644\u0629 \u0644\u062D\u0627\u0644\u0627\u062A \u062D\u0631\u062C\u0629 \u062C\u062F\u064B\u0627 \u0623\u0648 \u0646\u0642\u0644 \u0628\u064A\u0646 \u0627\u0644\u0645\u0633\u062A\u0634\u0641\u064A\u0627\u062A"
  }
};

// packages/isomorphic/src/lib/auth-claims.ts
var MUST_CHANGE_PASSWORD_CLAIM = "mustChangePassword";

// packages/isomorphic/src/lib/calculate-total.ts
import { differenceInDays } from "date-fns";

// packages/isomorphic/src/lib/schedule-time.ts
var SCHEDULE_TIME_PATTERN = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;
var MINUTES_PER_DAY = 24 * 60;
function parseScheduleTime(value) {
  const match = SCHEDULE_TIME_PATTERN.exec(value);
  if (!match) {
    throw new Error(`Invalid schedule time: ${value}`);
  }
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  const seconds = Number(match[3]);
  return {
    hours,
    minutes,
    seconds,
    totalMinutes: hours * 60 + minutes + seconds / 60
  };
}
function toScheduleTime(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    throw new Error(`Invalid schedule time date: ${value}`);
  }
  return `${date.getHours().toString().padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`;
}
function calculateDailyWorkingHours(from, to) {
  const fromMinutes = parseScheduleTime(from).totalMinutes;
  let toMinutes = parseScheduleTime(to).totalMinutes;
  if (toMinutes <= fromMinutes) {
    toMinutes += MINUTES_PER_DAY;
  }
  return (toMinutes - fromMinutes) / 60;
}

// packages/isomorphic/src/lib/calculate-total.ts
function calculateTotal(params) {
  const workingDays = differenceInDays(
    new Date(params.scheduleEndDate),
    new Date(params.scheduleStartDate)
  ) + 1;
  const workingHoursPerDay = calculateDailyWorkingHours(
    params.scheduleHoursFrom,
    params.scheduleHoursTo
  );
  const subtotal = params.priceItems.reduce(
    (sum, item) => sum + item.unitPrice * item.count,
    0
  );
  const total = subtotal * workingDays * workingHoursPerDay;
  return { subtotal, workingDays, workingHoursPerDay, total };
}

// packages/isomorphic/src/lib/calculate-monthly-installments.ts
import {
  addMonths,
  differenceInDays as differenceInDays2,
  differenceInMonths,
  getDaysInMonth
} from "date-fns";
var SHORT_TERM_MAX_DAYS = 30;
var SHORT_TERM_SPLIT_OPTIONS = [
  [40, 60],
  [50, 50],
  [60, 40]
];
var MIN_FIRST_PAYMENT_PERCENT = 20;
function isShortTermProject(startDate, endDate) {
  return differenceInDays2(new Date(endDate), new Date(startDate)) <= SHORT_TERM_MAX_DAYS;
}
function calculateMonthlyInstallments(startDate, endDate, firstPaymentPercent) {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const totalMonths = differenceInMonths(end, start);
  if (totalMonths < 1) {
    return [];
  }
  if (totalMonths === 1) {
    return [
      { percentage: firstPaymentPercent, name: null },
      { percentage: 100 - firstPaymentPercent, name: null }
    ];
  }
  const remaining = 100 - firstPaymentPercent;
  const remainingMonths = totalMonths - 1;
  const fullMonthEnd = addMonths(start, totalMonths);
  const partialDays = differenceInDays2(end, fullMonthEnd);
  if (partialDays > 0) {
    const daysInPartialMonth = getDaysInMonth(fullMonthEnd);
    const equalShare2 = Math.round(remaining / remainingMonths * 100) / 100;
    const proratedShare = Math.round(equalShare2 * (partialDays / daysInPartialMonth) * 100) / 100;
    const fullSharesTotal = equalShare2 * (remainingMonths - 1) + proratedShare;
    const lastFullShare = Math.round((remaining - fullSharesTotal) * 100) / 100;
    const installments2 = [
      { percentage: firstPaymentPercent, name: null }
    ];
    for (let i = 0; i < remainingMonths - 1; i++) {
      installments2.push({ percentage: equalShare2, name: null });
    }
    installments2.push({ percentage: lastFullShare, name: null });
    installments2.push({ percentage: proratedShare, name: null });
    return installments2;
  }
  const equalShare = Math.round(remaining / remainingMonths * 100) / 100;
  const othersTotal = equalShare * (remainingMonths - 1);
  const lastShare = Math.round((remaining - othersTotal) * 100) / 100;
  const installments = [
    { percentage: firstPaymentPercent, name: null }
  ];
  for (let i = 0; i < remainingMonths - 1; i++) {
    installments.push({ percentage: equalShare, name: null });
  }
  installments.push({ percentage: lastShare, name: null });
  return installments;
}

// packages/isomorphic/src/lib/offer-timeline.ts
import { addDays } from "date-fns";

// packages/client/dist/index.js
import "zod";
import z from "zod";
import { parse } from "fast-content-type-parse";
import { z as z2 } from "zod";
import "zod";
import { z as z4 } from "zod";
import "zod";
import { z as z6 } from "zod";
import "zod";
import { z as z8 } from "zod";
import "zod";
import { z as z10 } from "zod";
import "zod";
import { z as z12 } from "zod";
import "zod";
import { z as z14 } from "zod";
import "zod";
import { z as z16 } from "zod";
import "zod";
import { z as z18 } from "zod";
import z21 from "zod";
import "zod";
function template(templateString, templateVariables) {
  const nargs = /{([0-9a-zA-Z_]+)}/g;
  return templateString.replace(nargs, (match, key, index) => {
    if (templateString[index - 1] === "{" && templateString[index + match.length] === "}") {
      return key;
    }
    const result = key in templateVariables ? templateVariables[key] : null;
    return result === null || result === void 0 ? "" : String(result);
  });
}
var Serializer = class {
  input;
  props;
  constructor(input, props) {
    this.input = input;
    this.props = props;
  }
  serialize(path) {
    const params = this.props.inputParams.reduce(
      (acc, key) => {
        acc[key] = this.input[key];
        return acc;
      },
      {}
    );
    const url = new URL(template(path, params), `local://`);
    const headers = new Headers({});
    for (const header of this.props.inputHeaders) {
      headers.set(header, this.input[header]);
    }
    for (const key of this.props.inputQuery) {
      const value = this.input[key];
      if (value !== void 0) {
        if (Array.isArray(value)) {
          for (const item of value) {
            url.searchParams.append(key, String(item));
          }
        } else {
          url.searchParams.set(key, String(value));
        }
      }
    }
    return {
      body: this.getBody(),
      url,
      headers: this.getHeaders()
    };
  }
};
var JsonSerializer = class extends Serializer {
  getBody() {
    const body = {};
    if (this.props.inputBody.length === 1 && this.props.inputBody[0] === "$body") {
      return JSON.stringify(this.input.$body);
    }
    for (const prop of this.props.inputBody) {
      body[prop] = this.input[prop];
    }
    return JSON.stringify(body);
  }
  getHeaders() {
    return {
      "Content-Type": "application/json",
      Accept: "application/json"
    };
  }
};
var EmptySerializer = class extends Serializer {
  getBody() {
    return null;
  }
  getHeaders() {
    return {};
  }
};
function json(input, props) {
  return new JsonSerializer(input, props);
}
function empty(input, props) {
  return new EmptySerializer(input, props);
}
function toRequest(endpoint, serializer) {
  const [method, path] = endpoint.split(" ");
  const input = serializer.serialize(path);
  return {
    url: input.url,
    init: {
      method,
      headers: new Headers(input.headers),
      body: method === "GET" ? void 0 : input.body
    }
  };
}
function isBinaryContentType(contentType) {
  const type = contentType.toLowerCase();
  if (type.startsWith("image/")) {
    return true;
  }
  if (type.startsWith("audio/")) {
    return true;
  }
  if (type.startsWith("video/")) {
    return true;
  }
  switch (type) {
    case "application/pdf":
    case "application/zip":
    case "application/gzip":
    case "application/x-7z-compressed":
    case "application/x-tar":
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
    case "application/vnd.ms-excel":
    case "application/vnd.ms-powerpoint":
    case "application/msword":
    case "application/octet-stream":
      return true;
    default:
      return false;
  }
}
async function buffered(response) {
  const contentType = response.headers.get("Content-Type");
  if (!contentType) {
    throw new Error("Content-Type header is missing");
  }
  if (response.status === 204) {
    return null;
  }
  const { type } = parse(contentType);
  if (isBinaryContentType(type)) {
    return response.blob();
  }
  if (type.startsWith("text/")) {
    return response.text();
  }
  switch (type) {
    case "application/json":
      return response.json();
    case "application/xml":
      return response.text();
    case "application/x-www-form-urlencoded": {
      const text = await response.text();
      return Object.fromEntries(new URLSearchParams(text));
    }
    case "multipart/form-data":
      return response.formData();
    default:
      throw new Error(`Unsupported content type: ${contentType}`);
  }
}
var APIResponse = class {
  static status;
  status;
  data;
  headers;
  constructor(status, headers, data) {
    this.status = status;
    this.headers = headers;
    this.data = data;
  }
  static create(status, headers, data) {
    return new this(status, headers, data);
  }
};
var APIError = class extends APIResponse {
  static create(status, headers, data) {
    return new this(status, headers, data);
  }
};
var Ok = class _Ok extends APIResponse {
  static status = 200;
  constructor(headers, data) {
    super(_Ok.status, headers, data);
  }
  static create(status, headers, data) {
    return new this(headers, data);
  }
};
var Created = class _Created extends APIResponse {
  static status = 201;
  constructor(headers, data) {
    super(_Created.status, headers, data);
  }
  static create(status, headers, data) {
    return new this(headers, data);
  }
};
var NoContent = class _NoContent extends APIResponse {
  static status = 204;
  constructor(headers) {
    super(_NoContent.status, headers, null);
  }
  static create(status, headers) {
    return new this(headers);
  }
};
var BadRequest = class _BadRequest extends APIError {
  static status = 400;
  constructor(headers, data) {
    super(_BadRequest.status, headers, data);
  }
  static create(status, headers, data) {
    return new this(headers, data);
  }
};
var Unauthorized = class _Unauthorized extends APIError {
  static status = 401;
  constructor(headers, data) {
    super(_Unauthorized.status, headers, data);
  }
  static create(status, headers, data) {
    return new this(headers, data);
  }
};
var Forbidden = class _Forbidden extends APIError {
  static status = 403;
  constructor(headers, data) {
    super(_Forbidden.status, headers, data);
  }
  static create(status, headers, data) {
    return new this(headers, data);
  }
};
var NotFound = class _NotFound extends APIError {
  static status = 404;
  constructor(headers, data) {
    super(_NotFound.status, headers, data);
  }
  static create(status, headers, data) {
    return new this(headers, data);
  }
};
var Conflict = class _Conflict extends APIError {
  static status = 409;
  constructor(headers, data) {
    super(_Conflict.status, headers, data);
  }
  static create(status, headers, data) {
    return new this(headers, data);
  }
};
var UnsupportedMediaType = class _UnsupportedMediaType extends APIError {
  static status = 415;
  constructor(headers, data) {
    super(_UnsupportedMediaType.status, headers, data);
  }
  static create(status, headers, data) {
    return new this(headers, data);
  }
};
var fetchType = z.function().args(z.custom()).returns(z.promise(z.custom())).optional();
async function parse2(outputs10, response, mapper) {
  let output = null;
  let parser = buffered;
  for (const outputType of outputs10) {
    if ("parser" in outputType) {
      parser = outputType.parser;
      if (isTypeOf(outputType.type, APIResponse)) {
        if (response.status === outputType.type.status) {
          output = outputType.type;
          break;
        }
      }
    } else if (isTypeOf(outputType, APIResponse)) {
      if (response.status === outputType.status) {
        output = outputType;
        break;
      }
    }
  }
  if (response.ok) {
    const data = await parser(response);
    const mapped = mapper ? mapper(data) : data;
    const apiresponse = (output || APIResponse).create(
      response.status,
      response.headers,
      mapped
    );
    return apiresponse;
  }
  throw (output || APIError).create(
    response.status,
    response.headers,
    await parser(response)
  );
}
function isTypeOf(instance, baseType) {
  if (instance === baseType) {
    return true;
  }
  const prototype = Object.getPrototypeOf(instance);
  if (prototype === null) {
    return false;
  }
  return isTypeOf(prototype, baseType);
}
var Dispatcher = class {
  #interceptors = [];
  #fetch;
  constructor(interceptors, fetch2) {
    this.#interceptors = interceptors;
    this.#fetch = fetch2;
  }
  async send(config, outputs10, signal, mapper) {
    for (const interceptor of this.#interceptors) {
      if (interceptor.before) {
        config = await interceptor.before(config);
      }
    }
    const init = signal === void 0 ? config.init : { ...config.init, signal };
    let response = await (this.#fetch ?? fetch)(new Request(config.url, init));
    for (let i = this.#interceptors.length - 1; i >= 0; i--) {
      const interceptor = this.#interceptors[i];
      if (interceptor.after) {
        response = await interceptor.after(response.clone());
      }
    }
    if (mapper) {
      return await parse2(outputs10, response, mapper);
    }
    return await parse2(outputs10, response);
  }
};
var listAdminsSchema = z2.object({
  page: z2.coerce.number().int().gt(0).optional().default(1),
  pageSize: z2.coerce.number().int().min(1).max(1e3).optional().default(50),
  query: z2.union([z2.string(), z2.string(), z2.string()]).optional(),
  sortBy: z2.enum(["firstName", "lastName", "email", "createdAt"]).optional().default("createdAt"),
  sortOrder: z2.enum(["asc", "desc"]).optional().default("desc")
});
var getCurrentUserSchema = z2.object({}).catchall(z2.unknown());
var updateCurrentAdminSchema = z2.object({
  firstName: z2.string().optional(),
  lastName: z2.string().optional()
});
var createAdminSchema = z2.object({
  email: z2.string().email(),
  firstName: z2.string(),
  lastName: z2.string()
});
var updateAdminSchema = z2.object({
  email: z2.string().email().optional(),
  firstName: z2.string().optional(),
  lastName: z2.string().optional(),
  id: z2.string()
});
var deleteAdminSchema = z2.object({ id: z2.string() });
var listDocumentReviewsSchema = z2.object({
  page: z2.coerce.number().int().gt(0).optional().default(1),
  pageSize: z2.coerce.number().int().min(1).max(1e3).optional().default(50),
  sortBy: z2.enum(["createdAt", "updatedAt"]).optional().default("createdAt"),
  sortOrder: z2.enum(["asc", "desc"]).optional().default("desc")
});
var getDocumentReviewSchema = z2.object({ offerId: z2.string().uuid() });
var approveOfferDocumentSchema = z2.object({
  documentId: z2.string().uuid()
});
var rejectOfferDocumentSchema = z2.object({
  reason: z2.string().optional(),
  documentId: z2.string().uuid()
});
var listTTReviewsSchema = z2.object({
  page: z2.coerce.number().int().gt(0).optional().default(1),
  pageSize: z2.coerce.number().int().min(1).max(1e3).optional().default(50),
  sortBy: z2.string().optional().default("createdAt"),
  sortOrder: z2.enum(["asc", "desc"]).optional().default("desc")
});
var approveTTReviewSchema = z2.object({ offerId: z2.string().uuid() });
var rejectTTReviewSchema = z2.object({
  reason: z2.string().optional(),
  offerId: z2.string().uuid()
});
var getOfferTimelineSchema = z2.object({ id: z2.string().uuid() });
var getSignedDocumentLinksSchema = z2.object({
  submissionId: z2.string()
});
var admins_default = {
  "GET /admins": {
    schema: listAdminsSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /admins",
        empty(input, {
          inputHeaders: [],
          inputQuery: ["page", "pageSize", "query", "sortBy", "sortOrder"],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /admin/me": {
    schema: getCurrentUserSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /admin/me",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "PATCH /admin/me": {
    schema: updateCurrentAdminSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "PATCH /admin/me",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["firstName", "lastName"],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /admin": {
    schema: createAdminSchema,
    output: [
      Created,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /admin",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["email", "firstName", "lastName"],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "PATCH /admin/{id}": {
    schema: updateAdminSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "PATCH /admin/{id}",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["email", "firstName", "lastName"],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "DELETE /admin/{id}": {
    schema: deleteAdminSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "DELETE /admin/{id}",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /admin/document-reviews": {
    schema: listDocumentReviewsSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /admin/document-reviews",
        empty(input, {
          inputHeaders: [],
          inputQuery: ["page", "pageSize", "sortBy", "sortOrder"],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /admin/document-reviews/{offerId}": {
    schema: getDocumentReviewSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /admin/document-reviews/{offerId}",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["offerId"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "PATCH /admin/offer-documents/{documentId}/approve": {
    schema: approveOfferDocumentSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      Conflict,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "PATCH /admin/offer-documents/{documentId}/approve",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["documentId"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "PATCH /admin/offer-documents/{documentId}/reject": {
    schema: rejectOfferDocumentSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "PATCH /admin/offer-documents/{documentId}/reject",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["reason"],
          inputParams: ["documentId"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /admin/tt-reviews": {
    schema: listTTReviewsSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /admin/tt-reviews",
        empty(input, {
          inputHeaders: [],
          inputQuery: ["page", "pageSize", "sortBy", "sortOrder"],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /admin/tt-reviews/{offerId}/approve": {
    schema: approveTTReviewSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /admin/tt-reviews/{offerId}/approve",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["offerId"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /admin/tt-reviews/{offerId}/reject": {
    schema: rejectTTReviewSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /admin/tt-reviews/{offerId}/reject",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["reason"],
          inputParams: ["offerId"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /admin/offers/{id}/timeline": {
    schema: getOfferTimelineSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /admin/offers/{id}/timeline",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /admin/signing/{submissionId}/document": {
    schema: getSignedDocumentLinksSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      NotFound,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /admin/signing/{submissionId}/document",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["submissionId"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  }
};
var changeOwnPasswordSchema = z4.object({ newPassword: z4.string() });
var firebaseAuthActionSchema = z4.object({
  mode: z4.enum(["resetPassword", "verifyEmail"]),
  oobCode: z4.string(),
  apiKey: z4.string(),
  lang: z4.string().optional()
});
var forgotPasswordSchema = z4.object({ email: z4.string().email() });
var passwordChangedSchema = z4.object({ email: z4.string().email() });
var auth_default = {
  "POST /me/password": {
    schema: changeOwnPasswordSchema,
    output: [
      NoContent,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /me/password",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["newPassword"],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /auth/action": {
    schema: firebaseAuthActionSchema,
    output: [
      APIResponse,
      BadRequest,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /auth/action",
        empty(input, {
          inputHeaders: [],
          inputQuery: ["mode", "oobCode", "apiKey", "lang"],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /auth/forgot-password": {
    schema: forgotPasswordSchema,
    output: [
      Ok,
      BadRequest,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /auth/forgot-password",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["email"],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /auth/password-changed": {
    schema: passwordChangedSchema,
    output: [
      Ok,
      BadRequest,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /auth/password-changed",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["email"],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  }
};
var listCustomersSchema = z6.object({
  page: z6.coerce.number().int().gt(0).optional().default(1),
  pageSize: z6.coerce.number().int().min(1).max(1e3).optional().default(50),
  query: z6.union([z6.string(), z6.string(), z6.string()]).optional(),
  sortBy: z6.enum(["name", "email", "createdAt", "approved"]).optional().default("createdAt"),
  sortOrder: z6.enum(["asc", "desc"]).optional().default("desc")
});
var getCurrentCustomerSchema = z6.object({}).catchall(z6.unknown());
var updateCustomerSchema = z6.object({
  bankCertificate: z6.string().optional(),
  commercialRegistrationFile: z6.string().optional(),
  companyLogo: z6.string().optional(),
  firstName: z6.string().optional(),
  jobTitle: z6.string().optional(),
  lastName: z6.string().optional(),
  name: z6.string().optional(),
  nationalAddressCertificate: z6.string().optional(),
  phoneNumber: z6.string().optional(),
  signatoryEmail: z6.string().email().optional(),
  signatoryFirstName: z6.string().optional(),
  signatoryJobTitle: z6.string().optional(),
  signatoryLastName: z6.string().optional(),
  taxCertificate: z6.string().optional(),
  zakaCertificate: z6.string().optional()
});
var acceptCustomerTermsSchema = z6.object({}).catchall(z6.unknown());
var getProfileSchema = z6.object({}).catchall(z6.unknown());
var getCustomerDocumentsByIdSchema = z6.object({ id: z6.string() });
var getCustomerDocumentsSchema = z6.object({}).catchall(z6.unknown());
var createCustomerRequiredDocumentSchema = z6.object({
  fileId: z6.string().optional(),
  name: z6.string(),
  reason: z6.string(),
  id: z6.string()
});
var resolveCustomerRequiredDocumentSchema = z6.object({
  id: z6.string(),
  fileId: z6.string()
});
var createCustomerSchema = z6.object({
  email: z6.string().email(),
  id: z6.string(),
  name: z6.string(),
  termsAccepted: z6.boolean().default(true)
});
var updateCustomerByIdSchema = z6.object({
  address: z6.union([z6.string(), z6.string().default("")]).optional(),
  commercialRegistrationNumber: z6.union([z6.string(), z6.string().default("")]).optional(),
  email: z6.string().email().optional(),
  name: z6.string().optional(),
  id: z6.string()
});
var deleteCustomerSchema = z6.object({ id: z6.string() });
var approveCustomerSchema = z6.object({ id: z6.string() });
var rejectCustomerSchema = z6.object({
  reason: z6.string().optional(),
  id: z6.string()
});
var customers_default = {
  "GET /customers": {
    schema: listCustomersSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /customers",
        empty(input, {
          inputHeaders: [],
          inputQuery: ["page", "pageSize", "query", "sortBy", "sortOrder"],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /customer/me": {
    schema: getCurrentCustomerSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /customer/me",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "PATCH /customer/me": {
    schema: updateCustomerSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "PATCH /customer/me",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [
            "bankCertificate",
            "commercialRegistrationFile",
            "companyLogo",
            "firstName",
            "jobTitle",
            "lastName",
            "name",
            "nationalAddressCertificate",
            "phoneNumber",
            "signatoryEmail",
            "signatoryFirstName",
            "signatoryJobTitle",
            "signatoryLastName",
            "taxCertificate",
            "zakaCertificate"
          ],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /customer/me/accept-terms": {
    schema: acceptCustomerTermsSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /customer/me/accept-terms",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /customer/me/profile": {
    schema: getProfileSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      NotFound,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /customer/me/profile",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /customer/{id}/documents": {
    schema: getCustomerDocumentsByIdSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /customer/{id}/documents",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /customer/me/documents": {
    schema: getCustomerDocumentsSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /customer/me/documents",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /customer/{id}/request-documents": {
    schema: createCustomerRequiredDocumentSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /customer/{id}/request-documents",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["fileId", "name", "reason"],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "PATCH /customer/{id}/request-documents/{fileId}/resolve": {
    schema: resolveCustomerRequiredDocumentSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      NotFound,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "PATCH /customer/{id}/request-documents/{fileId}/resolve",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id", "fileId"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /customer": {
    schema: createCustomerSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /customer",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["email", "id", "name", "termsAccepted"],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "PATCH /customer/{id}": {
    schema: updateCustomerByIdSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "PATCH /customer/{id}",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [
            "address",
            "commercialRegistrationNumber",
            "email",
            "name"
          ],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "DELETE /customer/{id}": {
    schema: deleteCustomerSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      Conflict,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "DELETE /customer/{id}",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "PATCH /customer/{id}/approve": {
    schema: approveCustomerSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      Conflict,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "PATCH /customer/{id}/approve",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "PATCH /customer/{id}/reject": {
    schema: rejectCustomerSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      Conflict,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "PATCH /customer/{id}/reject",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["reason"],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  }
};
var getSignedUrlSchema = z8.object({
  name: z8.string(),
  size: z8.number().optional(),
  type: z8.enum([
    "application/pdf",
    "image/png",
    "image/jpeg",
    "image/jpg",
    "application/dicom"
  ])
});
var markFileAsUsedSchema = z8.object({ id: z8.string() });
var getFilesSchema = z8.object({ userId: z8.string().optional() });
var getFileByIdSchema = z8.object({ id: z8.string() });
var getFileAccessSchema = z8.object({
  id: z8.string(),
  purpose: z8.enum(["view", "download"])
});
var files_default = {
  "POST /signed-url": {
    schema: getSignedUrlSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /signed-url",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["name", "size", "type"],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /files/{id}/used": {
    schema: markFileAsUsedSchema,
    output: [
      Created,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /files/{id}/used",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /files": {
    schema: getFilesSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /files",
        empty(input, {
          inputHeaders: [],
          inputQuery: ["userId"],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /files/{id}": {
    schema: getFileByIdSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /files/{id}",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /files/{id}/access": {
    schema: getFileAccessSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /files/{id}/access",
        empty(input, {
          inputHeaders: [],
          inputQuery: ["purpose"],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  }
};
var listNotificationsSchema = z10.object({
  read: z10.union([
    z10.string().optional().default("false"),
    z10.boolean().optional().default(false)
  ]).optional(),
  page: z10.coerce.number().int().gt(0).optional().default(1),
  pageSize: z10.coerce.number().int().min(1).max(1e3).optional().default(50)
});
var markNotificationAsReadSchema = z10.object({ id: z10.string().uuid() });
var markAllNotificationsAsReadSchema = z10.object({}).catchall(z10.unknown());
var notifications_default = {
  "GET /notifications": {
    schema: listNotificationsSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /notifications",
        empty(input, {
          inputHeaders: [],
          inputQuery: ["read", "page", "pageSize"],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "PUT /notifications/{id}/read": {
    schema: markNotificationAsReadSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "PUT /notifications/{id}/read",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "PUT /notifications/mark-all-read": {
    schema: markAllNotificationsAsReadSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "PUT /notifications/mark-all-read",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  }
};
var listOffersSchema = z12.object({
  requestId: z12.string().uuid(),
  page: z12.coerce.number().int().gt(0).optional().default(1),
  pageSize: z12.coerce.number().int().min(1).max(1e3).optional().default(50),
  sortBy: z12.enum(["createdAt", "updatedAt"]).optional().default("createdAt"),
  sortOrder: z12.enum(["asc", "desc"]).optional().default("desc"),
  status: z12.enum(["PENDING", "ACCEPTED", "IN_PROGRESS", "CANCELED", "NOT_SELECTED"]).optional()
});
var createOfferSchema = z12.object({
  notes: z12.string().optional(),
  priceItems: z12.array(
    z12.object({
      serviceName: z12.string(),
      serviceType: z12.string(),
      count: z12.number().int().gt(0),
      unitPrice: z12.number().gt(0)
    })
  ),
  requestId: z12.string().uuid()
});
var listMyOffersSchema = z12.object({
  page: z12.coerce.number().int().gt(0).optional().default(1),
  pageSize: z12.coerce.number().int().min(1).max(1e3).optional().default(50),
  sortBy: z12.enum(["createdAt", "updatedAt"]).optional().default("createdAt"),
  sortOrder: z12.enum(["asc", "desc"]).optional().default("desc"),
  status: z12.enum(["PENDING", "ACCEPTED", "IN_PROGRESS", "CANCELED", "NOT_SELECTED"]).optional()
});
var acceptOfferSchema = z12.object({
  requiredDocuments: z12.array(z12.string()).optional().default([]),
  id: z12.string().uuid()
});
var getOfferPdfSchema = z12.object({ id: z12.string().uuid() });
var getOfferDocumentsSchema = z12.object({ id: z12.string().uuid() });
var uploadOfferDocumentSchema = z12.object({
  fileId: z12.string().uuid().optional(),
  requirementId: z12.string().uuid(),
  id: z12.string().uuid()
});
var deleteOfferDocumentSchema = z12.object({
  id: z12.string().uuid(),
  docId: z12.string().uuid()
});
var uploadOfferTTSchema = z12.object({
  fileId: z12.string().uuid().optional(),
  id: z12.string().uuid()
});
var deleteOfferTTSchema = z12.object({ id: z12.string().uuid() });
var uploadVendorTTSchema = z12.object({
  fileId: z12.string().uuid().optional(),
  id: z12.string().uuid()
});
var deleteVendorTTSchema = z12.object({ id: z12.string().uuid() });
var approveVendorTTSchema = z12.object({ id: z12.string().uuid() });
var rejectVendorTTSchema = z12.object({
  reason: z12.string().optional(),
  id: z12.string().uuid()
});
var getVendorBankCertificateSchema = z12.object({
  id: z12.string().uuid()
});
var getOfferContractStatusSchema = z12.object({ id: z12.string().uuid() });
var offers_default = {
  "GET /offers": {
    schema: listOffersSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /offers",
        empty(input, {
          inputHeaders: [],
          inputQuery: [
            "requestId",
            "page",
            "pageSize",
            "sortBy",
            "sortOrder",
            "status"
          ],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /offers": {
    schema: createOfferSchema,
    output: [
      Created,
      BadRequest,
      Unauthorized,
      Conflict,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /offers",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["notes", "priceItems", "requestId"],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /me/offers": {
    schema: listMyOffersSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /me/offers",
        empty(input, {
          inputHeaders: [],
          inputQuery: ["page", "pageSize", "sortBy", "sortOrder", "status"],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /offers/{id}/accept": {
    schema: acceptOfferSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Conflict,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /offers/{id}/accept",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["requiredDocuments"],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /offers/{id}/pdf": {
    schema: getOfferPdfSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /offers/{id}/pdf",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /offers/{id}/documents": {
    schema: getOfferDocumentsSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /offers/{id}/documents",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /offers/{id}/documents": {
    schema: uploadOfferDocumentSchema,
    output: [
      Created,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /offers/{id}/documents",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["fileId", "requirementId"],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "DELETE /offers/{id}/documents/{docId}": {
    schema: deleteOfferDocumentSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "DELETE /offers/{id}/documents/{docId}",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id", "docId"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /offers/{id}/tt": {
    schema: uploadOfferTTSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /offers/{id}/tt",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["fileId"],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "DELETE /offers/{id}/tt": {
    schema: deleteOfferTTSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "DELETE /offers/{id}/tt",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /offers/{id}/vendor-tt": {
    schema: uploadVendorTTSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /offers/{id}/vendor-tt",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["fileId"],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "DELETE /offers/{id}/vendor-tt": {
    schema: deleteVendorTTSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "DELETE /offers/{id}/vendor-tt",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /offers/{id}/vendor-tt/approve": {
    schema: approveVendorTTSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /offers/{id}/vendor-tt/approve",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /offers/{id}/vendor-tt/reject": {
    schema: rejectVendorTTSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /offers/{id}/vendor-tt/reject",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["reason"],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /offers/{id}/vendor-bank-certificate": {
    schema: getVendorBankCertificateSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      NotFound,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /offers/{id}/vendor-bank-certificate",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /offers/{id}/contract/status": {
    schema: getOfferContractStatusSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /offers/{id}/contract/status",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  }
};
var listAdminRequestsSchema = z14.object({
  page: z14.coerce.number().int().gt(0).optional().default(1),
  pageSize: z14.coerce.number().int().min(1).max(1e3).optional().default(50),
  sortBy: z14.enum(["createdAt", "updatedAt", "projectName", "proposalDeadline"]).optional().default("createdAt"),
  sortOrder: z14.enum(["asc", "desc"]).optional().default("desc"),
  query: z14.union([z14.string(), z14.string(), z14.string()]).optional()
});
var listRequestsSchema = z14.object({
  page: z14.coerce.number().int().gt(0).optional().default(1),
  pageSize: z14.coerce.number().int().min(1).max(1e3).optional().default(50),
  sortBy: z14.enum(["createdAt", "updatedAt"]).optional().default("createdAt"),
  sortOrder: z14.enum(["asc", "desc"]).optional().default("desc"),
  status: z14.enum(["PENDING", "ACCEPTED", "IN_PROGRESS", "CANCELED", "NOT_SELECTED"]).optional()
});
var createRequestSchema = z14.object({
  ambulance4x4WithDriver: z14.object({
    amount: z14.number().int().min(0),
    equipment: z14.array(
      z14.object({ name: z14.string(), quantity: z14.number().int().min(1) })
    ).optional().default([])
  }).optional(),
  ambulance4x4WithoutDriver: z14.object({
    amount: z14.number().int().min(0),
    equipment: z14.array(
      z14.object({ name: z14.string(), quantity: z14.number().int().min(1) })
    ).optional().default([])
  }).optional(),
  ambulanceServiceWithDriver: z14.array(
    z14.object({
      type1Amount: z14.number().int().min(0),
      type2Amount: z14.number().int().min(0),
      type3Amount: z14.number().int().min(0),
      type1Equipment: z14.array(
        z14.object({ name: z14.string(), quantity: z14.number().int().min(1) })
      ).optional().default([]),
      type2Equipment: z14.array(
        z14.object({ name: z14.string(), quantity: z14.number().int().min(1) })
      ).optional().default([]),
      type3Equipment: z14.array(
        z14.object({ name: z14.string(), quantity: z14.number().int().min(1) })
      ).optional().default([])
    })
  ).optional(),
  ambulanceServiceWithoutDriver: z14.array(
    z14.object({
      type1Amount: z14.number().int().min(0),
      type2Amount: z14.number().int().min(0),
      type3Amount: z14.number().int().min(0),
      type1Equipment: z14.array(
        z14.object({ name: z14.string(), quantity: z14.number().int().min(1) })
      ).optional().default([]),
      type2Equipment: z14.array(
        z14.object({ name: z14.string(), quantity: z14.number().int().min(1) })
      ).optional().default([]),
      type3Equipment: z14.array(
        z14.object({ name: z14.string(), quantity: z14.number().int().min(1) })
      ).optional().default([])
    })
  ).optional(),
  bankGuaranteePercent: z14.number().min(0).max(20).optional(),
  dates: z14.object({ from: z14.string().datetime(), to: z14.string().datetime() }),
  doctorServices: z14.array(
    z14.object({ specialization: z14.string(), amount: z14.number().int().min(1) })
  ).optional(),
  draftId: z14.string().uuid().optional(),
  hours: z14.object({ from: z14.string(), to: z14.string() }),
  housingTransportProvided: z14.boolean(),
  isolatedWorkArea: z14.boolean(),
  kpis: z14.array(z14.string()).optional().default([]),
  location: z14.object({ name: z14.string(), latitude: z14.number(), longitude: z14.number() }).optional(),
  mealsProvided: z14.boolean(),
  medicalEquipment: z14.array(z14.object({ name: z14.string(), quantity: z14.number().int().min(1) })).optional().default([]),
  mobileClinicServices: z14.array(
    z14.object({
      amount: z14.number().int().min(1),
      type: z14.enum(["BASIC", "ADVANCED"]),
      equipment: z14.array(
        z14.object({ name: z14.string(), quantity: z14.number().int().min(1) })
      ).optional().default([])
    })
  ).optional(),
  notes: z14.string().optional(),
  nurseServices: z14.array(
    z14.object({
      amount: z14.number().int().min(1),
      type: z14.enum(["SPECIALIST", "TECHNICIAN"])
    })
  ).optional(),
  paramedicServices: z14.array(
    z14.object({
      amount: z14.number().int().min(1),
      type: z14.enum(["SPECIALIST", "TECHNICIAN"])
    })
  ).optional(),
  paymentSchedule: z14.union([
    z14.object({
      paymentType: z14.string().default("MONTHLY"),
      milestones: z14.array(
        z14.object({
          percentage: z14.number().min(0).max(100).refine(
            (val) => Number.isInteger(val / 5),
            "Must be a multiple of 5"
          )
        })
      )
    }),
    z14.object({
      paymentType: z14.string().default("DELIVERABLES"),
      milestones: z14.array(
        z14.object({
          name: z14.string(),
          percentage: z14.number().min(0).max(100).refine(
            (val) => Number.isInteger(val / 5),
            "Must be a multiple of 5"
          )
        })
      )
    })
  ]),
  projectName: z14.string(),
  projectType: z14.enum(["GOVERNMENT", "PRIVATE"]),
  proposalDeadline: z14.string().datetime(),
  requiredDocuments: z14.array(z14.string()).optional().default([])
});
var listMyRequestsSchema = z14.object({
  page: z14.coerce.number().int().gt(0).optional().default(1),
  pageSize: z14.coerce.number().int().min(1).max(1e3).optional().default(50),
  sortBy: z14.enum(["createdAt", "updatedAt"]).optional().default("createdAt"),
  sortOrder: z14.enum(["asc", "desc"]).optional().default("desc"),
  status: z14.enum(["PENDING", "ACCEPTED", "IN_PROGRESS", "CANCELED", "NOT_SELECTED"]).optional(),
  active: z14.union([z14.string().optional(), z14.boolean().optional()]).optional()
});
var listVendorRequestsSchema = z14.object({
  page: z14.coerce.number().int().gt(0).optional().default(1),
  pageSize: z14.coerce.number().int().min(1).max(1e3).optional().default(50),
  sortBy: z14.enum(["createdAt", "updatedAt"]).optional().default("createdAt"),
  sortOrder: z14.enum(["asc", "desc"]).optional().default("desc")
});
var getRequestSchema = z14.object({ id: z14.string().uuid() });
var listMyRequestDraftsSchema = z14.object({}).catchall(z14.unknown());
var createMyRequestDraftSchema = z14.object({
  data: z14.object({}).catchall(z14.unknown()),
  id: z14.string().uuid().optional()
});
var getMyRequestDraftSchema = z14.object({ id: z14.string().uuid() });
var updateMyRequestDraftSchema = z14.object({
  data: z14.object({}).catchall(z14.unknown()).optional(),
  id: z14.string().uuid()
});
var deleteMyRequestDraftSchema = z14.object({ id: z14.string().uuid() });
var requests_default = {
  "GET /admin/requests": {
    schema: listAdminRequestsSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /admin/requests",
        empty(input, {
          inputHeaders: [],
          inputQuery: ["page", "pageSize", "sortBy", "sortOrder", "query"],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /requests": {
    schema: listRequestsSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /requests",
        empty(input, {
          inputHeaders: [],
          inputQuery: ["page", "pageSize", "sortBy", "sortOrder", "status"],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /requests": {
    schema: createRequestSchema,
    output: [
      Created,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /requests",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [
            "ambulance4x4WithDriver",
            "ambulance4x4WithoutDriver",
            "ambulanceServiceWithDriver",
            "ambulanceServiceWithoutDriver",
            "bankGuaranteePercent",
            "dates",
            "doctorServices",
            "draftId",
            "hours",
            "housingTransportProvided",
            "isolatedWorkArea",
            "kpis",
            "location",
            "mealsProvided",
            "medicalEquipment",
            "mobileClinicServices",
            "notes",
            "nurseServices",
            "paramedicServices",
            "paymentSchedule",
            "projectName",
            "projectType",
            "proposalDeadline",
            "requiredDocuments"
          ],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /me/requests": {
    schema: listMyRequestsSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /me/requests",
        empty(input, {
          inputHeaders: [],
          inputQuery: [
            "page",
            "pageSize",
            "sortBy",
            "sortOrder",
            "status",
            "active"
          ],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /vendor/requests": {
    schema: listVendorRequestsSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /vendor/requests",
        empty(input, {
          inputHeaders: [],
          inputQuery: ["page", "pageSize", "sortBy", "sortOrder"],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /requests/{id}": {
    schema: getRequestSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /requests/{id}",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /me/request-drafts": {
    schema: listMyRequestDraftsSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /me/request-drafts",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /me/request-drafts": {
    schema: createMyRequestDraftSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /me/request-drafts",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["data", "id"],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /me/request-drafts/{id}": {
    schema: getMyRequestDraftSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /me/request-drafts/{id}",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "PATCH /me/request-drafts/{id}": {
    schema: updateMyRequestDraftSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "PATCH /me/request-drafts/{id}",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["data"],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "DELETE /me/request-drafts/{id}": {
    schema: deleteMyRequestDraftSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "DELETE /me/request-drafts/{id}",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  }
};
var listSettingsSchema = z16.object({
  key: z16.string().optional(),
  section: z16.string().optional(),
  isActive: z16.union([z16.string().optional(), z16.boolean().optional()]).optional()
});
var createSettingSchema = z16.object({
  description: z16.string().optional(),
  isActive: z16.boolean().default(true),
  key: z16.string(),
  section: z16.string().default("general"),
  value: z16.string()
});
var bulkUpsertSettingsSchema = z16.object({
  settings: z16.array(
    z16.object({
      key: z16.string(),
      value: z16.string(),
      section: z16.string().optional().default("general"),
      description: z16.string().optional(),
      isActive: z16.boolean().optional()
    })
  ).optional()
});
var updateSettingSchema = z16.object({
  description: z16.string().optional(),
  isActive: z16.boolean().optional(),
  value: z16.string().optional(),
  section: z16.string(),
  key: z16.string()
});
var deleteSettingSchema = z16.object({
  section: z16.string(),
  key: z16.string()
});
var settings_default = {
  "GET /settings": {
    schema: listSettingsSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /settings",
        empty(input, {
          inputHeaders: [],
          inputQuery: ["key", "section", "isActive"],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /settings": {
    schema: createSettingSchema,
    output: [
      Created,
      BadRequest,
      Unauthorized,
      Forbidden,
      Conflict,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /settings",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["description", "isActive", "key", "section", "value"],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "PATCH /settings/bulk": {
    schema: bulkUpsertSettingsSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "PATCH /settings/bulk",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["settings"],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "PATCH /settings/{section}/{key}": {
    schema: updateSettingSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "PATCH /settings/{section}/{key}",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["description", "isActive", "value"],
          inputParams: ["section", "key"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "DELETE /settings/{section}/{key}": {
    schema: deleteSettingSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "DELETE /settings/{section}/{key}",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["section", "key"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  }
};
var listVendorsSchema = z18.object({
  page: z18.coerce.number().int().gt(0).optional().default(1),
  pageSize: z18.coerce.number().int().min(1).max(1e3).optional().default(50),
  query: z18.union([z18.string(), z18.string(), z18.string()]).optional(),
  sortBy: z18.enum(["name", "email", "createdAt", "approved"]).optional().default("createdAt"),
  sortOrder: z18.enum(["asc", "desc"]).optional().default("desc")
});
var getCurrentVendorSchema = z18.object({}).catchall(z18.unknown());
var updateVendorSchema = z18.object({
  bankCertificate: z18.string().optional(),
  commercialRegistrationFile: z18.string().optional(),
  companyLogo: z18.string().optional(),
  firstName: z18.string().optional(),
  jobTitle: z18.string().optional(),
  lastName: z18.string().optional(),
  name: z18.string().optional(),
  nationalAddressCertificate: z18.string().optional(),
  phoneNumber: z18.string().optional(),
  redCrescentComplianceCertificate: z18.string().optional(),
  signatoryEmail: z18.string().email().optional(),
  signatoryFirstName: z18.string().optional(),
  signatoryJobTitle: z18.string().optional(),
  signatoryLastName: z18.string().optional(),
  taxCertificate: z18.string().optional(),
  zakaCertificate: z18.string().optional()
});
var acceptVendorTermsSchema = z18.object({}).catchall(z18.unknown());
var vendorsGetProfileSchema = z18.object({}).catchall(z18.unknown());
var getVendorDocumentsSchema = z18.object({ id: z18.string() });
var createVendorSchema = z18.object({
  email: z18.string().email(),
  id: z18.string(),
  name: z18.string(),
  termsAccepted: z18.boolean().default(true)
});
var updateVendorByIdSchema = z18.object({
  address: z18.union([z18.string(), z18.string().default("")]).optional(),
  bankAccountName: z18.union([z18.string(), z18.string().default("")]).optional(),
  bankName: z18.union([z18.string(), z18.string().default("")]).optional(),
  commercialRegistrationNumber: z18.union([z18.string(), z18.string().default("")]).optional(),
  email: z18.string().email().optional(),
  iban: z18.union([z18.string(), z18.string().default("")]).optional(),
  name: z18.string().optional(),
  id: z18.string()
});
var deleteVendorSchema = z18.object({ id: z18.string() });
var approveVendorSchema = z18.object({ id: z18.string() });
var rejectVendorSchema = z18.object({
  reason: z18.string().optional(),
  id: z18.string()
});
var vendorsGetVendorDocumentsSchema = z18.object({}).catchall(z18.unknown());
var createVendorRequiredDocumentSchema = z18.object({
  fileId: z18.string().optional(),
  name: z18.string(),
  reason: z18.string(),
  id: z18.string()
});
var resolveVendorRequiredDocumentSchema = z18.object({
  id: z18.string(),
  fileId: z18.string()
});
var vendors_default = {
  "GET /vendors": {
    schema: listVendorsSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /vendors",
        empty(input, {
          inputHeaders: [],
          inputQuery: ["page", "pageSize", "query", "sortBy", "sortOrder"],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /vendor/me": {
    schema: getCurrentVendorSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /vendor/me",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "PATCH /vendor/me": {
    schema: updateVendorSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "PATCH /vendor/me",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [
            "bankCertificate",
            "commercialRegistrationFile",
            "companyLogo",
            "firstName",
            "jobTitle",
            "lastName",
            "name",
            "nationalAddressCertificate",
            "phoneNumber",
            "redCrescentComplianceCertificate",
            "signatoryEmail",
            "signatoryFirstName",
            "signatoryJobTitle",
            "signatoryLastName",
            "taxCertificate",
            "zakaCertificate"
          ],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /vendor/me/accept-terms": {
    schema: acceptVendorTermsSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /vendor/me/accept-terms",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /vendor/me/profile": {
    schema: vendorsGetProfileSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      NotFound,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /vendor/me/profile",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /vendor/{id}/documents": {
    schema: getVendorDocumentsSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      NotFound,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /vendor/{id}/documents",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /vendor": {
    schema: createVendorSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /vendor",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["email", "id", "name", "termsAccepted"],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "PATCH /vendor/{id}": {
    schema: updateVendorByIdSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "PATCH /vendor/{id}",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [
            "address",
            "bankAccountName",
            "bankName",
            "commercialRegistrationNumber",
            "email",
            "iban",
            "name"
          ],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "DELETE /vendor/{id}": {
    schema: deleteVendorSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      Conflict,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "DELETE /vendor/{id}",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "PATCH /vendor/{id}/approve": {
    schema: approveVendorSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      Conflict,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "PATCH /vendor/{id}/approve",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "PATCH /vendor/{id}/reject": {
    schema: rejectVendorSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      Conflict,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "PATCH /vendor/{id}/reject",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["reason"],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "GET /vendor/me/documents": {
    schema: vendorsGetVendorDocumentsSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "GET /vendor/me/documents",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: []
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "POST /vendor/{id}/request-documents": {
    schema: createVendorRequiredDocumentSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "POST /vendor/{id}/request-documents",
        json(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: ["fileId", "name", "reason"],
          inputParams: ["id"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  },
  "PATCH /vendor/{id}/request-documents/{fileId}/resolve": {
    schema: resolveVendorRequiredDocumentSchema,
    output: [
      Ok,
      BadRequest,
      Unauthorized,
      Forbidden,
      NotFound,
      UnsupportedMediaType
    ],
    toRequest(input) {
      return toRequest(
        "PATCH /vendor/{id}/request-documents/{fileId}/resolve",
        empty(input, {
          inputHeaders: [],
          inputQuery: [],
          inputBody: [],
          inputParams: ["id", "fileId"]
        })
      );
    },
    async dispatch(input, options) {
      const dispatcher = new Dispatcher(options.interceptors, options.fetch);
      return dispatcher.send(
        this.toRequest(input),
        this.output,
        options?.signal
      );
    }
  }
};
var schemas_default = {
  ...admins_default,
  ...customers_default,
  ...vendors_default,
  ...files_default,
  ...requests_default,
  ...offers_default,
  ...notifications_default,
  ...auth_default,
  ...settings_default
};
var optionsSchema = z21.object({
  token: z21.union([
    z21.string(),
    z21.function().returns(z21.union([z21.string(), z21.promise(z21.string())]))
  ]).optional().transform(async (token) => {
    if (!token) return void 0;
    if (typeof token === "function") {
      token = await Promise.resolve(token());
    }
    return `Bearer ${token}`;
  }).describe(
    "Bearer token for authentication. Can be a string or a function that returns a string."
  ),
  fetch: fetchType.describe(
    "Custom fetch implementation. Defaults to globalThis.fetch."
  ),
  baseUrl: z21.union([
    z21.string(),
    z21.function().returns(z21.union([z21.string(), z21.promise(z21.string())]))
  ]).transform(async (baseUrl) => {
    if (typeof baseUrl === "function") {
      return Promise.resolve(baseUrl());
    }
    return baseUrl;
  }).describe(
    "Base URL of the API server. Can be a string or a function that returns a string."
  ),
  headers: z21.record(z21.string()).optional().describe("Default headers to include in all requests."),
  skipValidation: z21.boolean().optional().describe(
    "Skip request input validation. Client options and TypeScript types still enforce correct usage."
  )
});

// packages/isomorphic/src/lib/offer-timeline.ts
function deriveDocumentStatus(timeline, documentId) {
  const documentEvents = timeline.filter((e) => {
    if (e.type !== "DOCUMENT_SUBMITTED" && e.type !== "DOCUMENT_APPROVED" && e.type !== "DOCUMENT_REJECTED") {
      return false;
    }
    const context = e.context;
    return context?.documentId === documentId;
  }).sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
  if (documentEvents.length === 0) {
    return "NOT_SUBMITTED";
  }
  const latestEvent = documentEvents[0];
  switch (latestEvent.type) {
    case "DOCUMENT_SUBMITTED":
      return "PENDING";
    case "DOCUMENT_APPROVED":
      return "APPROVED";
    case "DOCUMENT_REJECTED":
      return "REJECTED";
    default:
      return "NOT_SUBMITTED";
  }
}
function getDocumentRejectionReason(timeline, documentId) {
  const documentEvents = timeline.filter((e) => {
    if (e.type !== "DOCUMENT_SUBMITTED" && e.type !== "DOCUMENT_APPROVED" && e.type !== "DOCUMENT_REJECTED") {
      return false;
    }
    const context = e.context;
    return context?.documentId === documentId;
  }).sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
  if (documentEvents.length === 0) {
    return null;
  }
  const latestEvent = documentEvents[0];
  if (latestEvent.type === "DOCUMENT_REJECTED") {
    const context = latestEvent.context;
    return context.reason ?? null;
  }
  return null;
}
function deriveTTStatus(timeline) {
  const ttEvents = timeline.filter(
    (e) => e.type === "TT_UPLOADED" || e.type === "TT_APPROVED" || e.type === "TT_REJECTED"
  ).sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
  if (ttEvents.length === 0) {
    return "NOT_UPLOADED";
  }
  const latestEvent = ttEvents[0];
  switch (latestEvent.type) {
    case "TT_UPLOADED":
      return "PENDING";
    case "TT_APPROVED":
      return "APPROVED";
    case "TT_REJECTED":
      return "REJECTED";
    default:
      return "NOT_UPLOADED";
  }
}
function getTTRejectionReason(timeline) {
  const ttEvents = timeline.filter(
    (e) => e.type === "TT_UPLOADED" || e.type === "TT_APPROVED" || e.type === "TT_REJECTED"
  ).sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
  if (ttEvents.length === 0) {
    return null;
  }
  const latestEvent = ttEvents[0];
  if (latestEvent.type === "TT_REJECTED") {
    const context = latestEvent.context;
    return context.reason ?? null;
  }
  return null;
}
function getTTUploadedAt(timeline) {
  const uploadEvent = timeline.filter((e) => e.type === "TT_UPLOADED").sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  )[0];
  if (!uploadEvent) {
    return null;
  }
  return new Date(uploadEvent.createdAt);
}
function deriveContractSignatureStatus(timeline) {
  const signatures = timeline.filter((e) => e.type === "CONTRACT_SIGNED");
  const vendorSigned = signatures.some((s) => s.source === "VENDOR");
  const customerSigned = signatures.some((s) => s.source === "CUSTOMER");
  return {
    vendorSigned,
    customerSigned,
    bothSigned: vendorSigned && customerSigned
  };
}
function deriveTTDeadline(timeline) {
  const signatures = timeline.filter((e) => e.type === "CONTRACT_SIGNED");
  const vendorSignature = signatures.find((s) => s.source === "VENDOR");
  const customerSignature = signatures.find((s) => s.source === "CUSTOMER");
  if (!vendorSignature || !customerSignature) {
    return null;
  }
  const lastSignatureDate = new Date(
    Math.max(
      new Date(vendorSignature.createdAt).getTime(),
      new Date(customerSignature.createdAt).getTime()
    )
  );
  return addDays(lastSignatureDate, 10);
}
function areAllDocumentsApproved(timeline, documentIds) {
  for (const documentId of documentIds) {
    const status = deriveDocumentStatus(timeline, documentId);
    if (status !== "APPROVED") {
      return false;
    }
  }
  return true;
}
function getContractSignatureData(timeline, source) {
  const signatureEvent = timeline.find(
    (e) => e.type === "CONTRACT_SIGNED" && e.source === source
  );
  if (!signatureEvent) {
    return null;
  }
  return signatureEvent.context;
}
function getContractSignatureWithDate(timeline, source) {
  const signatureEvent = timeline.find(
    (e) => e.type === "CONTRACT_SIGNED" && e.source === source
  );
  if (!signatureEvent) {
    return null;
  }
  const context = signatureEvent.context;
  return {
    ...context,
    signedAt: new Date(signatureEvent.createdAt)
  };
}
function getAnyDocumentRejectionReason(timeline, currentDocumentIds) {
  const documentEvents = timeline.filter(
    (e) => e.type === "DOCUMENT_SUBMITTED" || e.type === "DOCUMENT_APPROVED" || e.type === "DOCUMENT_REJECTED"
  ).sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
  const latestByDocId = /* @__PURE__ */ new Map();
  for (const event of documentEvents) {
    const context = event.context;
    if (context?.documentId && !latestByDocId.has(context.documentId)) {
      latestByDocId.set(context.documentId, event);
    }
  }
  for (const [documentId, event] of latestByDocId.entries()) {
    if (currentDocumentIds && !currentDocumentIds.includes(documentId)) {
      continue;
    }
    if (event.type === "DOCUMENT_REJECTED") {
      const context = event.context;
      return context.reason ?? null;
    }
  }
  return null;
}
function hasAnyDocumentRejected(timeline, currentDocumentIds) {
  return getAnyDocumentRejectionReason(timeline, currentDocumentIds) !== null;
}
function deriveVendorTTStatus(timeline) {
  const ttEvents = timeline.filter(
    (e) => e.type === "VENDOR_TT_UPLOADED" || e.type === "VENDOR_TT_APPROVED" || e.type === "VENDOR_TT_REJECTED"
  ).sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
  if (ttEvents.length === 0) {
    return "NOT_UPLOADED";
  }
  const latestEvent = ttEvents[0];
  switch (latestEvent.type) {
    case "VENDOR_TT_UPLOADED":
      return "PENDING";
    case "VENDOR_TT_APPROVED":
      return "APPROVED";
    case "VENDOR_TT_REJECTED":
      return "REJECTED";
    default:
      return "NOT_UPLOADED";
  }
}
function getVendorTTRejectionReason(timeline) {
  const ttEvents = timeline.filter(
    (e) => e.type === "VENDOR_TT_UPLOADED" || e.type === "VENDOR_TT_APPROVED" || e.type === "VENDOR_TT_REJECTED"
  ).sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
  if (ttEvents.length === 0) {
    return null;
  }
  const latestEvent = ttEvents[0];
  if (latestEvent.type === "VENDOR_TT_REJECTED") {
    const context = latestEvent.context;
    return context.reason ?? null;
  }
  return null;
}
function getVendorTTUploadedAt(timeline) {
  const uploadEvent = timeline.filter((e) => e.type === "VENDOR_TT_UPLOADED").sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  )[0];
  if (!uploadEvent) {
    return null;
  }
  return new Date(uploadEvent.createdAt);
}
function areBothTTsApproved(timeline) {
  const caTTApproved = timeline.some((e) => e.type === "TT_APPROVED");
  const vendorTTApproved = timeline.some(
    (e) => e.type === "VENDOR_TT_APPROVED"
  );
  return caTTApproved && vendorTTApproved;
}

// packages/isomorphic/src/lib/retry-until.ts
import pRetry from "p-retry";
async function retryUntil(fn, predicate, options = {}) {
  const { onFailedAttempt, ...pRetryOptions } = options;
  return pRetry(
    async (attempt) => {
      const result = await fn();
      if (await predicate(result)) {
        return result;
      }
      throw new Error("Predicate not satisfied");
    },
    {
      ...pRetryOptions,
      onFailedAttempt: async (error) => {
        if (onFailedAttempt) {
          await onFailedAttempt(error, error.attemptNumber, error.retriesLeft);
        }
      }
    }
  );
}

// packages/isomorphic/src/lib/vendor-exposure.ts
function exposeVendorInfo(vendor, timeline) {
  const { bothSigned } = deriveContractSignatureStatus(timeline);
  if (!bothSigned) {
    return { exposed: false, id: vendor.id };
  }
  return {
    exposed: true,
    id: vendor.id,
    name: vendor.name,
    email: vendor.email,
    contact: vendor.contact
  };
}

// packages/isomorphic/src/lib/service-map.ts
var SERVICE_MAP = {
  standard: "\u0645\u0648\u0639\u062F \u0645\u0639 \u0637\u0628\u064A\u0628",
  second_opinion: "\u0631\u0623\u064A \u0637\u0628\u064A \u062B\u0627\u0646\u064D"
};
var GENDER_MAP = {
  male: "\u0630\u0643\u0631",
  female: "\u0623\u0646\u062B\u0649"
};

// packages/isomorphic/src/lib/time-slots.ts
import { addHours, getHours, getMinutes, setMinutes } from "date-fns";
function roundDown30(date) {
  const minutes = getMinutes(date);
  const roundedMinutes = minutes < 30 ? 0 : 30;
  return setMinutes(date, roundedMinutes);
}
function roundUp30(date) {
  const minutes = getMinutes(date);
  if (minutes === 0 || minutes === 30) return date;
  const roundedMinutes = minutes < 30 ? 30 : 0;
  return roundedMinutes === 0 ? setMinutes(addHours(date, 1), 0) : setMinutes(date, 30);
}
function roundTo30(date) {
  const minutes = getMinutes(date);
  if (minutes < 15) {
    return setMinutes(date, 0);
  } else if (minutes < 45) {
    return setMinutes(date, 30);
  } else {
    return setMinutes(addHours(date, 1), 0);
  }
}
function overlap(slots) {
  const intervals = slots.map(({ startTime: start, endTime: end }) => ({
    start: Math.min(start, end),
    end: Math.max(start, end)
  }));
  for (let i = 1; i < intervals.length; i++) {
    for (let j = 0; j < i; j++) {
      if (intervals[i].start < intervals[j].end && intervals[i].end > intervals[j].start) {
        return i;
      }
    }
  }
  return -1;
}
function dateToMinutes(date) {
  return getHours(date) * 60 + getMinutes(date);
}
var APPOINTMENT_DURATION_MINUTES = 30;
var MINUTES_IN_DAY = 1440;
var LAST_MINUTE_OF_DAY = 1439;
function generateSlots(startTime, endTime) {
  const slots = [];
  for (let time = startTime; time < endTime; time += APPOINTMENT_DURATION_MINUTES) {
    slots.push({
      startTime: time,
      endTime: time + APPOINTMENT_DURATION_MINUTES
    });
  }
  return slots;
}

// packages/isomorphic/src/lib/validators.ts
import { parseISO } from "date-fns";
import parsePhoneNumber from "libphonenumber-js";
import { z as z3 } from "zod";
var validatePhoneNumber = async (value) => {
  const phoneNumber = parsePhoneNumber(value);
  return phoneNumber && phoneNumber.isValid();
};
var phoneValidator = (options) => async (value, ctx) => {
  try {
    const isEmpty = !value || value.length === 0;
    if (isEmpty && !options.validateEmpty) {
      return true;
    }
    const isValid = await validatePhoneNumber(value);
    if (!isValid) {
      ctx.addIssue({
        code: z3.ZodIssueCode.custom,
        message: "\u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D"
      });
      return false;
    }
    return true;
  } catch (error) {
    console.error(error);
    ctx.addIssue({
      code: z3.ZodIssueCode.custom,
      message: "\u0631\u0642\u0645 \u0627\u0644\u062C\u0648\u0627\u0644 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D"
    });
    return false;
  }
};
var futureDateSchema = z3.string().datetime().transform((date) => parseISO(date)).refine(
  (date) => {
    const nowUTC = /* @__PURE__ */ new Date();
    return date >= nowUTC;
  },
  {
    message: "Date must not be in the past"
  }
);
var stringBoolean = z3.coerce.string().or(z3.coerce.boolean()).nullish().transform((value) => {
  if (value === null || value === void 0) {
    return false;
  }
  if (typeof value === "string") {
    return value.toLowerCase() === "true";
  }
  return false;
});
var pageNumberSchema = z3.coerce.number().int().positive().nullish().default(1).transform((value) => value === null || value === void 0 ? 1 : value);
var pageSizeSchema = z3.coerce.number().int().min(1).max(100).nullish().default(50).transform((value) => value === null || value === void 0 ? 50 : value);
var searchQuerySchema = z3.string().min(2).max(100).trim().optional();
var sortOrderSchema = z3.enum(["asc", "desc"]).optional().default("asc");

// packages/isomorphic/src/lib/weekday.ts
var AR_DAYS_OF_WEEK = [
  "\u0627\u0644\u0633\u0628\u062A",
  "\u0627\u0644\u0623\u062D\u062F",
  "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
  "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
  "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
  "\u0627\u0644\u062E\u0645\u064A\u0633",
  "\u0627\u0644\u062C\u0645\u0639\u0629"
];
var EN_DAYS_OF_WEEK = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
];
var EN_AR_DAYS_OF_WEEK = {
  SUNDAY: "\u0627\u0644\u0623\u062D\u062F",
  MONDAY: "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
  TUESDAY: "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
  WEDNESDAY: "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
  THURSDAY: "\u0627\u0644\u062E\u0645\u064A\u0633",
  FRIDAY: "\u0627\u0644\u062C\u0645\u0639\u0629",
  SATURDAY: "\u0627\u0644\u0633\u0628\u062A"
};
var AR_TO_EN_DAYS_OF_WEEK = {
  \u0627\u0644\u0633\u0628\u062A: "SATURDAY",
  \u0627\u0644\u0623\u062D\u062F: "SUNDAY",
  \u0627\u0644\u0627\u062B\u0646\u064A\u0646: "MONDAY",
  \u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621: "TUESDAY",
  \u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621: "WEDNESDAY",
  \u0627\u0644\u062E\u0645\u064A\u0633: "THURSDAY",
  \u0627\u0644\u062C\u0645\u0639\u0629: "FRIDAY"
};
var weekdayMap = {
  0: "SUNDAY",
  1: "MONDAY",
  2: "TUESDAY",
  3: "WEDNESDAY",
  4: "THURSDAY",
  5: "FRIDAY",
  6: "SATURDAY"
};

// packages/isomorphic/src/lib/ordinal.ts
import { toOrdinal } from "n2words/ar-SA";
function toArabicOrdinal(n, gender) {
  return toOrdinal(n, { gender });
}

// packages/isomorphic/src/lib/profile-completeness.ts
var isBlank = (value) => value === null || value === void 0 || value.trim() === "";
var hasMissingSignatory = (fields) => isBlank(fields.signatoryFirstName) || isBlank(fields.signatoryLastName) || isBlank(fields.signatoryJobTitle) || isBlank(fields.signatoryEmail);
function getIncompleteProfileTab(user) {
  if (!user) return null;
  if (user.documentsComplete === false) return "account_documents";
  if (hasMissingSignatory(user)) return "signatory_info";
  return null;
}

// packages/isomorphic/src/index.ts
function isNullOrUndefined(value) {
  return value === void 0 || value === null;
}
function notNullOrUndefined(value) {
  return !isNullOrUndefined(value);
}
var formatCurrency = (amount) => new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "SAR"
}).format(amount);
export {
  AMBULANCE_SERVICE_TYPES,
  APPOINTMENT_DURATION_MINUTES,
  AR_DAYS_OF_WEEK,
  AR_TO_EN_DAYS_OF_WEEK,
  EN_AR_DAYS_OF_WEEK,
  EN_DAYS_OF_WEEK,
  GENDER_MAP,
  LAST_MINUTE_OF_DAY,
  MINUTES_IN_DAY,
  MIN_FIRST_PAYMENT_PERCENT,
  MUST_CHANGE_PASSWORD_CLAIM,
  SERVICE_MAP,
  SHORT_TERM_MAX_DAYS,
  SHORT_TERM_SPLIT_OPTIONS,
  areAllDocumentsApproved,
  areBothTTsApproved,
  calculateDailyWorkingHours,
  calculateMonthlyInstallments,
  calculateTotal,
  dateToMinutes,
  deriveContractSignatureStatus,
  deriveDocumentStatus,
  deriveTTDeadline,
  deriveTTStatus,
  deriveVendorTTStatus,
  exposeVendorInfo,
  formatCurrency,
  futureDateSchema,
  generateSlots,
  getAnyDocumentRejectionReason,
  getContractSignatureData,
  getContractSignatureWithDate,
  getDocumentRejectionReason,
  getIncompleteProfileTab,
  getTTRejectionReason,
  getTTUploadedAt,
  getVendorTTRejectionReason,
  getVendorTTUploadedAt,
  hasAnyDocumentRejected,
  isNullOrUndefined,
  isShortTermProject,
  notNullOrUndefined,
  overlap,
  pageNumberSchema,
  pageSizeSchema,
  parseScheduleTime,
  phoneValidator,
  retryUntil,
  roundDown30,
  roundTo30,
  roundUp30,
  searchQuerySchema,
  sortOrderSchema,
  stringBoolean,
  toArabicOrdinal,
  toScheduleTime,
  validatePhoneNumber,
  weekdayMap
};
//# sourceMappingURL=index.js.map
